@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Konzern auswählen"
           [ngModel]="filterText()"
           fullWidth
           [disabled]="true" />
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [(ngModel)]="filterText"
           placeholder="Konzern auswählen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth />
    @if (value) {
      <button nbSuffix nbButton ghost (click)="onClear()">
        <nb-icon icon="close-outline" pack="eva"></nb-icon>
      </button>
    }
  </nb-form-field>
}

<ng-template #popoverTemplate>
  <div class="autocomplete-dropdown">
    <nb-list>
      @for (group of filteredGroups(); track group.id) {
        <nb-list-item (click)="onSelectionChange(group)">
          <div class="group-item">{{ group.name }}</div>
        </nb-list-item>
      } @empty {
        <nb-list-item>
          <div class="group-item no-items">Keine Konzerne gefunden</div>
        </nb-list-item>
      }
    </nb-list>
  </div>
</ng-template>
